export default {
  // general
  'service_settings.update.error':
    'We are unable to update the service at this time. Please try again later.',

  // status checks
  'service_settings.status_checks.list.empty': 'No health checks to display',

  // tags
  'service_settings.tags.update.success': 'Service tags successfully updated',
  'service_settings.tags.delete.dialog_title': 'Delete `{{tagName}}`?',
  'service_settings.tags.delete.dialog_body':
    'Are you sure you want to delete tag `{{tagName}}`?',
  'service_settings.tags.description1': 'This service can use custom tags for',
  'service_settings.tags.description2': 'report',
  'service_settings.tags.description3': 'filtering.',
  'service_settings.tags.tag_name.label': 'Tag Name',
  'service_settings.tags.tag_values.label': 'Tag Values',
  'service_settings.tags.tag_values.helper_text':
    "Multiple values are supported: Click value(s) in the dropdown or type a single value or comma-separated values and press 'Enter'.",
  'service_settings.tags.values.label': 'Values',
  'service_settings.tags.new_tag_entry.add_button': 'Add Tag',
  'service_settings.tags.list.empty': 'No tags to display',
  'service_settings.tags.production_environment.checkbox.label.prefix':
    'This Service is in a ',
  'service_settings.tags.production_environment.title':
    'Production Environment',
  'service_settings.tags.production_environment.description':
    'Additional warnings will be shown before any action is taken. This tag can be used to filter reports like custom tags.',

  // tag validation
  'service_settings.tags.new_tag_entry.validation.tag_invalid':
    'Invalid characters. Must begin and end with an alphanumeric character ([a-z0-9A-Z]) with dashes (-), underscores (_), dots (.), and alphanumerics',
  'service_settings.tags.new_tag_entry.validation.tag_name_required':
    'Tag Name is required',
  'service_settings.tags.new_tag_entry.validation.tag_name_exists':
    'Tag with that name is already saved',
  'service_settings.tags.new_tag_entry.validation.tag_value_required':
    'At least one tag value is required'
}
